import React from 'react';
import { Card } from 'react-bootstrap';
import ApexChart from 'react-apexcharts';
import { FaChartPie } from 'react-icons/fa';

const generateColors = (count) => {
  const palette = [
    "#4e79a7", "#f28e2b", "#e15759", "#76b7b2",
    "#59a14f", "#edc948", "#b07aa1", "#ff9da7",
    "#9c755f", "#bab0ab", "#5f9ea0", "#c85200"
  ];
  return Array.from({ length: count }, (_, i) => palette[i % palette.length]);
};

const PieChartComponent = ({ data, title }) => {
  const chartSeries = data.map(item => item.value);
  const chartLabels = data.map(item => item.name);
  const chartColors = data.every(d => d.color) ? data.map(item => item.color) : generateColors(data.length);

  const chartOptions = {
    chart: {
      type: 'donut',
      toolbar: { show: false },
    },
    labels: chartLabels,
    colors: chartColors,
    legend: { show: false },
    dataLabels: {
      enabled: true,
      formatter: (val, opts) => {
        const count = opts.w.config.series[opts.seriesIndex];
        return `${count}`;
      },
      style: {
        fontSize: '12px',
        fontWeight: 600,
        colors: ['#ffffff'],
      },
    },
    tooltip: {
      y: {
        formatter: (value) => `${value} leads`,
      },
    },
    plotOptions: {
      pie: {
        donut: {
          labels: { show: false },
        },
      },
    },
  };

  return (
    <Card
      className="border-0 shadow-sm h-100 rounded-4"
      style={{
        background: 'linear-gradient(145deg, #28a74510, #28a74502)',
        backdropFilter: 'blur(2px)',
        transition: 'all 0.3s ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.08)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.04)';
      }}
    >
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h6 className="fw-bold text-dark mb-0">{title}</h6>
          <FaChartPie size={18} className="text-success" />
        </div>

        <div className="d-flex" style={{ minHeight: 230 }}>
          {/* Chart */}
          <div style={{ width: '60%' }}>
            <ApexChart
              options={chartOptions}
              series={chartSeries}
              type="donut"
              height={230}
            />
          </div>

          {/* Scrollable List */}
          <div
            style={{
              width: '40%',
              maxHeight: '230px',
              overflowY: data.length > 5 ? 'auto' : 'visible',
              paddingLeft: '12px',
              paddingRight: '4px',
            }}
          >
            {data.map((item, index) => (
              <div
                key={index}
                className="d-flex justify-content-between align-items-center mb-2"
              >
                <div className="d-flex align-items-center">
                  <div
                    className="me-2 rounded-circle"
                    style={{
                      width: "10px",
                      height: "10px",
                      backgroundColor: chartColors[index]
                    }}
                  />
                  <small className="text-muted">{item.name}</small>
                </div>
                <small className="fw-semibold">{item.value}</small>
              </div>
            ))}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default PieChartComponent;
